import {
    authUserAction,
    storeUserDetailsAction,
    saveAccessTokenAction,
    errorMessageAction,
} from "../Redux/Actions/actions";

const baseApiURL = window.location.origin;

export function ResetUserPassword(data) {

    const options = {

        method: "post",

        headers: {

            Accept: "application/json, text/plain, */*",

            "Content-Type": "application/json",

           // Authorization: "Bearer " + siteToken.token,

        },

        body: JSON.stringify(data),

    };

    return fetch(

        baseApiURL + "/Login/ChangePassword",

        options

    )

        .then((response) => response.json())

        .then((data) => {

            return data.result;

        })

        .catch((error) => {

            console.log("Error : ", error);

        });
}


    export function forgotUserPassword(data) {
        const options = {
            method: "post",
            headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json",
               // Authorization: "Bearer " + siteToken,
            },
            body: JSON.stringify(data),
        };
        return fetch(
            baseApiURL + "/Login/ForgotPassword",
            options
        )
            .then((response) => response.json())
            .then((data) => {
                return data.result;
            })
            .catch((error) => {
                console.log("Error : ", error);
            });
}

//VerifyOTP
export function verifyOTP(data) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            // Authorization: "Bearer " + siteToken,
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Login/VerifyOTP",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}

//verify otpo for customer
export function verifyOTPForCustomer(data) {
    const options = {
        method: "post",
        headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            // Authorization: "Bearer " + siteToken,
        },
        body: JSON.stringify(data),
    };
    return fetch(
        baseApiURL + "/Login/VerifyOTPCustomer",
        options
    )
        .then((response) => response.json())
        .then((data) => {
            return data.result;
        })
        .catch((error) => {
            console.log("Error : ", error);
        });
}
